// extracted by mini-css-extract-plugin
export default {"columnaPrincipal":"HomeTorneos_columnaPrincipal__Q40-t","contenedorCuadros":"HomeTorneos_contenedorCuadros__xQxh1","columnaLateral":"HomeTorneos_columnaLateral__DQl9L"};